import { Box, Divider, IconButton, Tooltip, alpha } from "@mui/material";
import SettingsIcon from "@mui/icons-material/Settings";
import MilitaryTechIcon from '@mui/icons-material/MilitaryTech';
import MapIcon from '@mui/icons-material/Map';

import { SIDEBAR_GAP, SIDEBAR_WIDTH } from './sidebarWidths';
import { CLOCK_THEMES } from './MapClock';
import { glassSx } from './overlayStyles';

// Panel switches at the top right of the Radar / Review map, as one vertical group.
// sidebarWidth: width of the sidebar that is open (the Units sidebar is wider than the others)
// active: which sidebar is open ('units' | 'settings' | 'map' | null) - shown highlighted
// mode: 'live' (Radar) | 'replay' (Review), for the accent color
const SettingsToggleButton = ({
  onUnitsClick,
  onSettingsClick,
  onMapSettingsClick,
  isOpen,
  sidebarWidth = SIDEBAR_WIDTH,
  active = null,
  mode = 'live',
}) => {
  const { accent } = CLOCK_THEMES[mode] || CLOCK_THEMES.live;
  const right = isOpen ? sidebarWidth + SIDEBAR_GAP : 12;

  const buttons = [
    { key: 'units', label: 'Units', hint: 'Choose the unit and radar station', Icon: MilitaryTechIcon, onClick: onUnitsClick },
    { key: 'settings', label: 'Radar settings', hint: 'Labels, speed unit, colors, track length', Icon: SettingsIcon, onClick: onSettingsClick },
    { key: 'map', label: 'Map settings', hint: 'Map type, borders, airports, outposts, regions', Icon: MapIcon, onClick: onMapSettingsClick },
  ];

  return (
    <Box
      sx={{
        position: 'absolute',
        top: 12,
        right,
        zIndex: 1000,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 0.25,
        p: 0.4,
        borderRadius: '12px',
        transition: 'right 0.3s ease-in-out, background-color .2s ease',
        ...glassSx(accent, { interactive: true }),
      }}
    >
      {buttons.map(({ key, label, hint, Icon, onClick }, i) => {
        const on = active === key;
        return (
          <Box key={key} display="contents">
            {i > 0 && <Divider flexItem sx={{ mx: 0.75, borderColor: 'rgba(255,255,255,0.12)' }} />}
            <Tooltip
              placement="left"
              arrow
              title={
                <Box sx={{ py: 0.25 }}>
                  <Box sx={{ fontWeight: 700, fontSize: '0.78rem' }}>{on ? `Close ${label.toLowerCase()}` : label}</Box>
                  <Box sx={{ fontSize: '0.7rem', opacity: 0.8 }}>{hint}</Box>
                </Box>
              }
            >
              <IconButton
                onClick={onClick}
                aria-label={label}
                aria-pressed={on}
                sx={{
                  width: 38,
                  height: 38,
                  borderRadius: '9px',
                  color: on ? accent : 'rgba(255,255,255,0.85)',
                  backgroundColor: on ? alpha(accent, 0.2) : 'transparent',
                  boxShadow: on ? `inset 0 0 0 1px ${alpha(accent, 0.7)}` : 'none',
                  filter: 'drop-shadow(0 1px 2px rgba(0,0,0,0.8))',
                  '&:hover': {
                    color: on ? accent : '#fff',
                    backgroundColor: on ? alpha(accent, 0.26) : 'rgba(255,255,255,0.12)',
                  },
                }}
              >
                <Icon sx={{ fontSize: '1.25rem' }} />
              </IconButton>
            </Tooltip>
          </Box>
        );
      })}
    </Box>
  );
};

export default SettingsToggleButton;
